/**
 * everything in here will only be loaded when the user actually loads the web-browser
 */

export default function () {
  return null;
}
